

const Navbar = () => {

    return(
        <div className="Navbar-div">
            <h2>Resume Builder</h2>
            <span>
               - made by Prateek
            </span>
        </div>
    )
}

export default Navbar;